//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TermsOfUse',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  mounted() {
  }
}
